import { styled } from '@mui/material/styles';

export const Root = styled('div')(() => ({
  height: '100%',
}));

export const ContentWrapper = styled('div', {
  shouldForwardProp: (prop) => !['$fixedSidebar'].includes(String(prop)),
})<{ $fixedSidebar?: boolean }>(({ $fixedSidebar }) => ({
  display: 'grid',
  gridTemplateColumns: $fixedSidebar ? '400px 1fr' : 'max-content 3fr',
}));

export const LeftBlock = styled('div')(() => ({
  display: 'flex',
  padding: 24,
  flexDirection: 'column',
  overflow: 'auto',
  height: 'calc(100vh - 70px)',
}));

export const RightBlock = styled('div')(() => ({
  height: 'calc(100vh - 70px)',
  backgroundColor: '#ffffff',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  borderLeft: '1px solid #ebf0f0',
}));

export const ChildrenWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  height: '100%',
  width: '100%',
  overflowY: 'auto',
}));
